import { List, Space } from "antd";
import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "src/context/GlobalContext";
import LightLogo from "../../assets/images/logo.png";
const Language = () => {
  const { levels, setLanguage } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const languageOptions = [
    { id: "tr", name: "Turkish" },
    { id: "ar", name: "Arabic" },
  ];
  return (
    <div className="container mx-auto p-2 min-h-screen">
      <img src={LightLogo} className="h-16" alt="logo" />
      <br />
      <br />
      <br />
      <p className="font-semibold text-lg text-red-500">
        PLEASE SELECT THE STUDENT'S LANGUAGE CLASS
      </p>
      <br />
      {/* <br />
      <Card className="text-center p-6">
        <p className="font-semibold text-2x text-red-500">
          The system is being updated for book sales in 2026. <br />
          Thank you for your understanding.
          <br />
          We will be back online as soon as possible.
        </p>
      </Card> */}
      <br />

      <List
        loading={levels === null}
        grid={{
          gutter: 16,
          xs: 2,
          sm: 2,
          md: 4,
          lg: 8,
          xl: 8,
          xxl: 8,
        }}
        dataSource={languageOptions}
        renderItem={(item, index) => (
          <List.Item
            onClick={() => {
              setLanguage(item.id);
              navigate("/store/" + id + "/" + item.id);
            }}
          >
            <div>
              <div className="bg-white p-4 text-center border border-gray-400 hover:border-gray-400 hover:shadow-lg  mt-4 text-base font-semibold cursor-pointer aspect-square items-center flex justify-center  shadow-inner">
                <Space direction="vertical" size="small">
                  <span className="text-sky-400 text-xl font-extrabold">
                    {item.name}
                  </span>
                </Space>
              </div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default Language;
